import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { Abbreviation, Book, BookForList, BookLanguagePreset, Language, copyRestObject } from "../../../rest/models";
import { useEffect, useRef, useState } from "react";
import { getModelMap } from "../../../rest/slice";
import { DictRequestStatusDisplay, PleaseWait, RequestStatusDisplay } from "../../CommonComponents";
import { BookEditForm } from "./BookEditForm";
import { GetPageTitle } from "../../../ErnotsConfig";
import { bookEditorActions } from "./slice";
import { RequestStatus } from "../../../api_request/api_request";
import { downloadObject } from "../../../rest/data";

/** The main component for the create/edit book page. */
export function BookEdit()
{
    const appDispatch = useAppDispatch();
    const bookId = useAppSelector(() => new URLSearchParams(window.location.search).get('bookId'));
    const presetId = useAppSelector(() => new URLSearchParams(window.location.search).get('presetId'));

    const [bookRequest, setBookRequest] = useState<RequestStatus|undefined>(undefined);

    //This object is manipulated in the form, while the actual book is untouched.
    const formBook = useAppSelector((state) => state.bookEditor.formBook);
    let preset = getModelMap(useAppSelector, BookLanguagePreset)?.[presetId ?? ''];

    //I want to call bookEditorActions.init() before the form loads.
    const initCompleteRef = useRef(false);

    useEffect(function()
    {
        //Completely clear the form's state.
        appDispatch(bookEditorActions.init());
        initCompleteRef.current = true;

        if (bookId)
        {
            downloadObject(Book, bookId, appDispatch, setBookRequest);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(function()
    {
        if (bookRequest?.inState)
        {
            appDispatch(bookEditorActions.setFormBook(copyRestObject(bookRequest.responseJson, Book)));
            appDispatch(bookEditorActions.sortAndSyncBookLanguages());
        }
    }, [appDispatch, bookRequest]);

    //Get auxiliary data.
    const abbrModels = getModelMap(useAppSelector, Abbreviation);
    const langModels = getModelMap(useAppSelector, Language);
    const bookModels = getModelMap(useAppSelector, BookForList);
    const presetModels = getModelMap(useAppSelector, BookLanguagePreset);

    const hasData = true
        && abbrModels != null
        && langModels != null
        && bookModels != null
        && presetModels != null
        && (formBook.id || !bookId)
        && (preset || !presetId)
        && initCompleteRef.current

    let main = <></>;
    if (hasData)
    {
        main =
        <BookEditForm
            formBook={formBook}
            preset={preset}
            abbrModels={abbrModels}
            langModels={langModels}
            bookModels={bookModels}
            presetModels={presetModels}/>
    }
    else
    {
        main =
        <>
            <title>{GetPageTitle('Editing Book')}</title>
            <PleaseWait what='book data'/>
            <DictRequestStatusDisplay modelClass={Abbreviation} />
            <DictRequestStatusDisplay modelClass={BookForList} />
            <DictRequestStatusDisplay modelClass={BookLanguagePreset} />
            <DictRequestStatusDisplay modelClass={Language} />

            <RequestStatusDisplay request={bookRequest} />
        </>;
    }

    return (
    <div className='ernots_BookEdit'>
        {main}
    </div>);
}